<template>
  <div v-bind:class="{'now_loading': (this.loading)}">
    <div v-show="loading" class="loader loader_bg--gray"></div>
    <div v-show="!loading" v-for="(val, n) in productList" :key="n" class="products_wrap beauty_wrap bg_white mt12 pt16 pb24 boxs2">
      <div class="bc_wrap">
        <h2 class="content_title">購入BC</h2>
        <div class="pl15 pr15">
          <h3 class="bc_number rb">BC：{{ val.bcNo }}</h3>
        </div>
      </div>
      <div v-show="!loading" v-for="(bcItem, l) in val.bcItemList" :key="l" class="pt15">
        <h2 class="content_title">{{ bcItem.genreName }}</h2>
        <p v-if="bcItem.genreId == 3" class="pl16 pr16 mt16 nselection_text ab">しおDASの定期購入を変更する、または停止する場合はテレフォンオーダーへご連絡ください。<br>テレフォンオーダー 0120-934-258 平日9時-18時（土・日・祝日休み）</p>
        <div class="product_list">
          <div class="product_item" v-for="(item, m) in bcItem.itemList" v-bind:class="{ 'select': item.repeatOrder }" v-on:click="selectItem(n, l, m)">
            <div class="products_main">
              <div class="product_image">
                <img :src="imagePath + item.product.imagePath" :alt="item.product.productName" v-on:error="imageError" :data-noimage="imagePath + item.product.noImagePath">
              </div>
              <h3 class="product_title">{{ item.product.productName }}</h3>
            </div>
            <div class="products_detail">
              <p class="product_price rb"><span class="yen">￥</span>{{ item.product.price.toLocaleString() }}</p>
              <p class="product_point rb"><span class="point">P</span>{{ item.product.point.toLocaleString() }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Config from '@/config/config'
import { mapGetters } from 'vuex'

export default {
  props: [],
  data() {
    return {
      imagePath: Config.APIURL,
      loading: true,
      productList: [],
      existRepeatItem: [],
      localStorageRepeatItem: []
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    selectItem(n, l, m) {
      if(this.productList[n].bcItemList[l].genreId == 3) return;
      if(this.productList[n].bcItemList[l].itemList[m].repeatOrder) {
        this.productList[n].bcItemList[l].itemList[m].repeatOrder = false;
        this.productList[n].bcItemList[l].itemList[m].orderCount = 1;
        this.productList[n].bcItemList[l].itemList[m].childFund = false;
      } else {
        this.productList[n].bcItemList[l].itemList[m].repeatOrder = true;
      }
    },
    storageGetProducts(repeatItem) {
      // データの重複を防ぐため、既存のリストをクリア
      this.productList.splice(0, this.productList.length);
      this.existRepeatItem.splice(0, this.existRepeatItem.length);

      this.productList.push(...repeatItem);
      const storageExistRepeatItem = JSON.parse(localStorage.getItem('recommendationExistRepeatItem'))
      storageExistRepeatItem ? this.existRepeatItem.push(...storageExistRepeatItem): ''; // すでに定期購入している商品リスト
      this.$emit('existRepeatItem', this.existRepeatItem);
      this.loading = false;
    },
    async init() {
      // プロダクトリストをクリア
      this.productList.splice(0, this.productList.length);
      this.existRepeatItem.splice(0, this.existRepeatItem.length);

      this.loadRecommendProducts();
    },
    loadRecommendProducts() {

      // 既存のproductListがある場合（戻った時など）は何もしない
      if (this.productList.length > 0) {
        this.loading = false;
        return;
      }

      // Vuexから推奨商品データを取得（可能な場合）
      const vuexRecommendProducts = this.recommendationRecommendProductMap;

      // データが存在しない場合は何もしない
      if (!vuexRecommendProducts || Object.keys(vuexRecommendProducts).length === 0) {
        this.loading = false;
        return;
      }

      // 全てのBCをループして処理
      for (const bcNo in vuexRecommendProducts) {
        const bcData = vuexRecommendProducts[bcNo];

        if (bcData.repeatOrdersList && bcData.repeatOrdersList.length > 0) {

          const bcItem = {
            bcNo: bcNo,
            bcItemList: []
          };

          // ジャンル別に商品をグループ化
          const genreMap = {};

          for (const item of bcData.repeatOrdersList) {
            const genreId = item.product.genre.genreId;
            const genreName = item.product.genre.genreName;

            if (!genreMap[genreId]) {
              genreMap[genreId] = {
                genreId: genreId,
                genreName: genreName,
                itemList: []
              };
            }

            // 推奨商品として事前選択状態で追加
            genreMap[genreId].itemList.push({
              ...item,
              repeatOrder: true // 推奨商品は初期選択状態
            });

            // 推奨商品を既存リストに追加
            this.existRepeatItem.push(item);
          }

          // ジャンル別のアイテムリストをbcItemListに追加
          for (const genreId in genreMap) {
            bcItem.bcItemList.push(genreMap[genreId]);
          }

          // productListに追加（テンプレートがv-for="(val, n) in productList"で参照）
          this.productList.push(bcItem);
        }
      }

      // 推奨商品があれば既存商品リストとして通知
      if (this.existRepeatItem.length > 0) {
        localStorage.setItem('recommendationExistRepeatItem', JSON.stringify(this.existRepeatItem));
        this.$emit('existRepeatItem', this.existRepeatItem);
      }
      this.loading = false;
    }
  },
  computed: mapGetters([
    'recommendationRecommendProductMap'
  ]),
  watch: {
    productList: {
      deep: true,
      handler() {
        localStorage.setItem('recommendationRepeatItemList', JSON.stringify(this.productList));
      }
    }
  },
  created() {
    // localStorageから既存の選択データを確認
    const repeatItem = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));

    this.localStorageRepeatItem = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));

    if (repeatItem && repeatItem.length > 0) {
      this.$nextTick(() => {
        this.storageGetProducts(repeatItem);
      });
    } else {
      // 初期化処理を実行
      this.$nextTick(() => {
        this.init();
      });
    }
  }
}
</script>

<style lang="css" scoped>
.nselection_text {
  font-size: 14px;
}
.bc_wrap .bc_number {
  font-size: 20px;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/subscriptionMulti/ProductList.vue